import { updateState } from '../helpers/utilityHelpers'

import {
  AUTH_FAILED,
  AUTH_LOGIN,
  AUTH_USER,
  AUTH_CHANGE_PROFILE,
  AUTH_CHANGE_PLAN,
  AUTH_CHANGE_LOADING,
  AUTH_UPDATE_DEFAULT_PLAN,
  AUTH_ADD_PLAN,
  AUTH_UPDATE_USER_DATA,
  AUTH_UPDATE_PROFILE_SELECTED_PLANS
} from '../actions/_actionTypes'
import { PlanGroupCategoryEnum } from 'settings/_planGroupSettings'

const {
  VITTA
} = PlanGroupCategoryEnum


export const initialState = {
  isAuth: false,
  isLoading: true,
  profilePermissions: null,
  failMessage: '',
  planSelected: null,
  profileSelected: null,
  userData: null,
  userToken: null,
}

const loginUser = (state, { payload }) => {
  return updateState(state, { userToken: payload.userToken })
}

const authUser = (state, { payload }) => {
  return updateState(state, {
    isAuth: true,
    isLoading: false,
    profilePermissions: payload.profilePermissions,
    failMessage: '',
    planSelected: payload.planSelected,
    profileSelected: payload.profileSelected,
    userData: payload.userData,
    userToken: payload.userToken,
  })
}

const authChangeLoading = (state, { payload }) => {
  return updateState(state, {
    isLoading: payload.isLoading,
  })
}

const authUpdateUserData = (state, { payload }) => {
  return updateState(state, { 
    userData: payload
  })
}

const changeProfile = (state) => {
  return updateState(state)
}

const authChangePlan = (state, { payload }) => {
  return updateState(state, { planSelected: payload.planSelected })
}

const authUpdateDefaultPlan = (state, { payload }) => {
  const allPlansWithDefaultFalse = state.profileSelected.plans.map(plan => ({
    ...plan,
    default: false
  }))
  
  const newProfileSelected = {
    ...state.profileSelected,
    plans: allPlansWithDefaultFalse.map(plan => plan.partner_plan_code === payload.planCode ? { ...plan, default: true } : plan)
  }

  return updateState(state, { profileSelected: newProfileSelected })
}

const authAddPlan = (state, { payload }) => {
  const newProfileSelected = {
    ...state.profileSelected,
    plans: [...state.profileSelected.plans, payload.newPlan]
  }

  return updateState(state, { 
    profileSelected: newProfileSelected,
    planSelected: state.planSelected.partner_plan_is_particular || state.planSelected.plan_group.category === VITTA ? payload.newPlan : state.planSelected
  })
}

const authFailed = (state, { payload }) => {
  return updateState(state, {
    ...initialState,
    failMessage: payload,
  })
}

const authUpdateProfileSelectedPlans = (state, { payload }) => {
  return updateState(state, {
    profileSelected: {
      ...state.profileSelected,
      plans: payload
    }
  })
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
  case AUTH_FAILED: return authFailed(state, action)
  case AUTH_LOGIN: return loginUser(state, action)
  case AUTH_USER: return authUser(state, action)
  case AUTH_CHANGE_PROFILE: return changeProfile(state)
  case AUTH_CHANGE_PLAN: return authChangePlan(state, action)
  case AUTH_CHANGE_LOADING: return authChangeLoading(state, action)
  case AUTH_UPDATE_DEFAULT_PLAN: return authUpdateDefaultPlan(state, action)
  case AUTH_ADD_PLAN: return authAddPlan(state, action)
  case AUTH_UPDATE_USER_DATA: return authUpdateUserData(state, action)
  case AUTH_UPDATE_PROFILE_SELECTED_PLANS: return authUpdateProfileSelectedPlans(state, action)
  default: return state
  }
}

export default authReducer
